export const provinceList =
    [
        {
            name_id: 'Nasional',
            name_en: 'National',
            extent: [94.747163, 5.993257, 144.695468, -11.419725],
        },
        {
            name_id: 'Jambi',
            name_en: 'Jambi',
            extent: [101.1284199, -2.77005799, 104.4910178, -0.730430926],
        },
        {
            name_id: 'Kalimantan Barat',
            name_en: 'West Kalimantan',
            extent: [108.0261402, -3.067918524, 114.2226404, 2.081301036],
        },
        {
            name_id: 'Kalimantan Selatan',
            name_en: 'South Kalimantan',
            extent: [114.3466009, -5.101754409, 117.4577926, -1.315039832],
        },
        {
            name_id: 'Kalimantan Tengah',
            name_en: 'Central Kalimantan',
            extent: [110.7344788, -3.543607224, 115.8472204, 0.777833182],
        },
        {
            name_id: 'Papua',
            name_en: 'Papua',
            extent: [134.5852579, -9.11759548, 141, -0.391876026],
        },
        {
            name_id: 'Riau',
            name_en: 'Riau',
            extent: [100.0209789, -1.12760203, 103.8135774, 2.537940153],
        },
        {
            name_id: 'Sumatera Selatan',
            name_en: 'South Sumatera',
            extent: [102.0414013, -4.924159182, 106.2206874, -1.626931463],
        },
    ];

export const clickableLayers =
    [
        {
            // name: 'rencana_restorasi_gambut:batas_khg',
            name: parseInt(process.env.MIX_MAP_KHG_LAYERITEM_ID),
            type: 'khg',
        },
        {
            name: parseInt(process.env.MIX_MAP_PROVINSI_LAYERITEM_ID),
            type: 'provinsi',
        },
        {
            name: parseInt(process.env.MIX_MAP_KABUPATEN_LAYERITEM_ID),
            type: 'kabupaten',
        },
        {
            name: parseInt(process.env.MIX_MAP_KECAMATAN_LAYERITEM_ID),
            type: 'kecamatan',
        },
        {
            // name: 'perencanaan:demplot_2017',
            name: parseInt(process.env.MIX_MAP_DEMPLOT_2017_LAYERITEM_ID),
            type: 'penelitian-plot',
        },
        {
            // name: 'perencanaan:demplot_2018',
            name: parseInt(process.env.MIX_MAP_DEMPLOT_2018_LAYERITEM_ID),
            type: 'penelitian-plot',
        },
        {
            // name: 'perencanaan:demplot_2019',
            name: parseInt(process.env.MIX_MAP_DEMPLOT_2019_LAYERITEM_ID),
            type: 'penelitian-plot',
        },
        {
            // name: 'perencanaan:demplot_2020',
            name: parseInt(process.env.MIX_MAP_DEMPLOT_2020_LAYERITEM_ID),
            type: 'penelitian-plot',
        },
        {
            // name: 'prims_d4:gwl:status=1',
            name: parseInt(process.env.MIX_MAP_GWL_AMAN_LAYERITEM_ID),
            type: 'sipalaga',
        },
        {
            // name: 'prims_d4:gwl:status=2',
            name: parseInt(process.env.MIX_MAP_GWL_WASPADA_LAYERITEM_ID),
            type: 'sipalaga',
        },
        {
            // name: 'prims_d4:gwl:status=3',
            name: parseInt(process.env.MIX_MAP_GWL_BAHAYA_LAYERITEM_ID),
            type: 'sipalaga',
        },
        {
            // name: 'rencana_restorasi_gambut:piezometer_staffgaugae',
            name: parseInt(process.env.MIX_MAP_RISET_SKALA_TAPAK_GWL_LAYERITEM_ID),
            type: 'impact-research',
        },
    ];

/* hydrology model */
process.env.MIX_MAP_HYDROLOGY_MODEL_LAYERITEM_ID.split(",").map((layerItem) => {
    clickableLayers.push({
        name: parseInt(layerItem),
        type: 'hydrology-model'
    });
});